/* eslint-disable max-len */
export const VIEW_ADMIN = 'View_Admin';
export const VIEW_SCHEDULER = 'View_Scheduler';
export const VIEW_TRUCKING_LC = 'View_Trucking_LC';
export const VIEW_WAREHOUSE_LC = 'View_Warehouse_LC';
export const VIEW_CMS_PRICING = 'View_CMS_Pricing';
export const VIEW_PRICING_INBOX = 'View_Pricing_Inbox';
export const VIEW_ORGANIZATIONS = 'View_Organizations';
export const VIEW_ORDERS = 'View_Orders';
export const VIEW_WAREHOUSE_APP = 'View_Warehouse_App';
export const EDIT_TRUCK_LOANS = 'Edit_Truck_Loans';
export const VIEW_PRICING_ADMIN = 'View_Pricing_Admin';
export const VIEW_PRICING_QUOTES = 'View_Pricing_Quotes';
export const CREATE_ORDER = 'Create_Order';
export const VIEW_CLERK_SIGNATURE = 'View_Clerk_Signature';
export const VIEW_CLERKING_BAY_LOCATIONS = 'View_Clerking_Bay_Locations';
export const VIEW_OPERATOR_BAY_LOCATIONS = 'View_Operator_Bay_Locations';
export const VIEW_HELP_LOADS = 'View_Help_Loads';
export const VIEW_UNASSIGNED_LOADS = 'View_Unassigned_Loads';
export const ASSIGN_TO_LOAD = 'Assign_To_Load';
export const VIEW_ACCOUNTING_STATUS = 'View_Accounting_Status';
export const VIEW_LOADS_ON_LOGIN = 'View_Loads_On_Login';
export const VIEW_WAREHOUSE_DASHBOARD = 'View_Warehouse_Dashboard';
export const VIEW_CLERKING_OPTIONS = 'View_Clerking_Options';
export const CAN_VIEW_CMS = 'CMS_Access';
export const VIEW_INVOICING = 'View_Invoicing';
export const VIEW_BOTH_DISPATCH_ORDERS = 'View_Both_Dispatch_Orders';
export const VIEW_LEGACY_ONLY_DISPATCH = 'View_Legacy_Only_Dispatch';
export const VIEW_MODERN_ONLY_DISPATCH = 'View_Modern_Only_Dispatch';
export const VIEW_BOTH_SCHEDULER_ORDERS = 'View_Both_Scheduler_Orders';
export const VIEW_LEGACY_ONLY_SCHEDULER_ORDERS = 'View_Legacy_Only_Scheduler';
export const VIEW_MODERN_ONLY_SCHEDULER_ORDERS = 'View_Modern_Only_Scheduler';
export const VIEW_DISPATCHING = 'View_Dispatching';
export const VIEW_DRIVER_SETTLEMENTS = 'View_Driver_Settlements';
export const VIEW_DRIVER_SETTLEMENTS_DRIVERS_MODULE = 'View_Driver_Settlements_Drivers_Module';
export const VIEW_DRIVER_SETTLEMENTS_OWNERS_MODULE = 'View_Driver_Settlements_Owners_Module';
export const VIEW_DRIVER_SETTLEMENTS_PROCESSING_MODULE = 'View_Driver_Settlements_Processing_Module';
export const VIEW_DRIVER_SETTLEMENTS_STREET_TURN_ADDITIONAL_PAY_MODULE = 'View_Driver_Settlements_Street_Turn_Additional_Pay_Module';
export const VIEW_DRIVER_SETTLEMENTS_TRUCK_DETAILS = 'View_Driver_Settlements_Truck_Details';
export const VIEW_DRIVER_SETTLEMENTS_TRUCK_MODULE = 'View_Driver_Settlements_Truck_Module';
export const VIEW_DRIVER_SETTLEMENTS_UNITS_MODULE = 'View_Driver_Settlements_Units_Module';
export const VIEW_SAFETY = 'View_Safety';
export const VIEW_V2_WAREHOUSE_MODULE = 'View_V2_Warehouse_Module';
export const VIEW_REPAIR_ORDER = 'View_Repair_Order';
export const VIEW_CLAIMS = 'View_Claims';
export const DO_IMPERSONATION = 'Do_Impersonation';
export const USE_MESSAGING = 'Use_Messaging';
export const EDIT_ACCEPTED_QUOTES = 'Edit_Accepted_Quotes';
export const DOWNLOAD_QUOTE_LANE_PDF = 'Download_Quote_Lane_PDF';
// Safety
export const SAFETY_READ_ONLY = 'Safety_Read_Only';
export const SAFETY_COORDINATOR = 'Safety_Coordinator';
export const SAFETY_MANAGER = 'Safety_Manager';
export const PERMIT_LOCATION_APPROVAL = 'PermitLocation_Approval';
export const SAFETY_DISPATCHER_ACCESS = 'Safety_Dispatcher_Access';
export const MULE_ASSIGNMENT = 'Mule_Assignment';
export const EDIT_TRUCK_VIN = 'Edit_Truck_Vin';
export const TERMINATE_DRIVERS_AND_TRUCKS = 'Terminate_Drivers_and_Trucks';
// Pricing -> Quotes
export const QUOTES_EDIT = 'Quotes_Edit';
export const QUOTES_READ = 'Quotes_Read';
export const VIEW_COST_PROFIT_MARGINS = 'View_Cost_Profit_Margins';
export const EDIT_LC_FIELD = 'Edit_LC_Field';
export const EDIT_QUOTE_LANE_STATUS = 'Edit_Quote_Lane_Status';

// Admin
export const GENERAL_GOD = 'GeneralGod';
// Admin -> Customer Logins
export const READ_CUSTOMER_LOGINS = 'CustomerLogin_Read';
export const EDIT_CUSTOMER_LOGINS = 'CustomerLogin_Edit';
export const MARGIN_OVERRIDE = 'MarginOverride';
// Dispatch
export const DISPATCH_MANAGER = 'Dispatch_Manager';
